import React from "react";
import { Flex, type FlexProps } from "@chakra-ui/react";
import { Button } from "ui/button";
import { useDemoLinkWithParameters } from "hooks/use-demo-link";
import { useColorTheme } from "contexts/color-theme";
import { trackDemoButtonClicked, trackLoginClicked } from "components/event-tracking";

type CtaButtonsProps = {
  hasJustifiedButtons?: boolean;
  hasLogin?: boolean;
} & FlexProps;

export function CtaButtons({ hasJustifiedButtons, hasLogin = true, ...props }: CtaButtonsProps) {
  const demoLinkWithParameters = useDemoLinkWithParameters();
  const { theme } = useColorTheme();

  return (
    <Flex flex={1} align="center" justify="end" gap="smallest" {...props}>
      {hasLogin && (
        <Button
          href="https://app.hightouch.com/login"
          target="_blank"
          variant="secondary"
          flex={hasJustifiedButtons ? 1 : undefined}
          onClick={trackLoginClicked}
        >
          Log in
        </Button>
      )}
      <Button
        hasRightChevron
        pulse={theme}
        href={demoLinkWithParameters}
        flex={hasJustifiedButtons ? 1 : undefined}
        onClick={trackDemoButtonClicked}
      >
        Get a demo
      </Button>
    </Flex>
  );
}
